import bleach from 'bleach';

export const sanitizeContent = (content, options = {}) => {
	const newOptions = {
		...options,
		mode: 'black',
		list: ['script']
	};

	return bleach.sanitize(content, newOptions);
};
